import React, { useState, useEffect} from "react";
import {
  Tabs,
  Tab,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Typography,
  TextField,
  Grid2,
  MenuItem,
  Select,
  TablePagination,
  TableSortLabel,
  Drawer,
  IconButton
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import config from '../../config/config.js';
import analyticsConfig from "./analyticsConfig"; // Config file
import Navbar from "../navbar/Navbar"; // Navbar component
import Sidemenu from "../sidemenu/Sidemenu"; // Sidemenu component
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {useNavigate } from 'react-router-dom';
import exportCSVIcon from '../../assets/icons/exportCSVIcon.svg';
import CloseIcon from "@mui/icons-material/Close";

const DynamicAnalytics = () => {
  const cities = JSON.parse(localStorage.getItem('cities'));

  const [cityFilter, setCityFilter] = useState(cities[0].city_id);
  const serverUrl = config.serverUrl;
  const client_id = localStorage.getItem('clientId');
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0); // Track active tab
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]); // Rows after filtering
  const [searchDriverId, setSearchDriverId] = useState(""); // Track input value for driver_id search
  const [searchPromoName, setSearchPromoName] = useState(""); // Track input value for promoName search
  const [searchPartnerName, setSearchPartnerName] = useState(""); // Track input value for partnerName search
  const [txnTypeFilter, setTxnTypeFilter] = useState("all"); //Dynamic txnType filter 
  const [dateFilter, setDateFilter] = useState("today"); // Default date filter
  const [startDate, setStartDate] = useState(dayjs().startOf("day")); // Set default to start of today
  const [endDate, setEndDate] = useState(dayjs().startOf("day"));
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [errorMessage, setErrorMessage] = useState('');
  const [tokenExpired, setTokenExpired] = useState(false);
  const utcOffset = parseInt(localStorage.getItem('utc_offset') || '330', 10);
  const timeZoneFormat = localStorage.getItem('time_zone_format') || '12';
  const [selectedPromotion, setSelectedPromotion] = useState(null);
  const [showPromotionDetails, setShowPromotionDetails] = useState(false);
  const token = localStorage.getItem("token");
  const [loadingRedemptions, setLoadingRedemptions] = useState(false);
  const [promoRedemptions, setPromoRedemptions] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [userTypeFilter, setUserTypeFilter] = useState("all");
  const fleetId = localStorage.getItem('fleetId'); 
  const [adminNameFilter, setAdminNameFilter] = useState("all");


  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('name');

  const is_rizzo_client = localStorage.getItem('is_rizzo_client');
  const disable_total_rides_for_taxi = localStorage.getItem('disable_total_rides_for_taxi');


const handleExportPromoRedemptionCsv = () => {
  if (!promoRedemptions?.length) return;

  const headers = [
    "User ID",
    "User Name",
    "Phone",
    "Engagement ID",
    "Redemption Time",
    "Original Fare",
    "Discount Applied",
    "Final Fare",
    "Promo Count"
  ];

  const csvRows = promoRedemptions.map((item) => {
    const redemptionTime = `${formatDate(item.redemption_timestamp)} ${formatTime(item.redemption_timestamp)}`;

    return [
      item.user_id,
      item.user_name,
      item.phone,
      item.engagement_id,
      redemptionTime,
      item.original_fare,
      item.discount_applied,
      item.final_fare_paid,
      item.user_promo_count
    ]
      .map((v) => `"${v ?? ""}"`)
      .join(",");
  });

  const csvContent = [headers.join(","), ...csvRows].join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `promo_redemptions_${selectedPromotion?.promo_id || "export"}.csv`;
  link.click();
};

  // Handle Tab Change
  const handleTabChange = (event, newValue) => {
      setActiveTab(newValue);
      setSearchDriverId(""); // Clear the search input
      setFilteredRows(rows); // Reset filtered rows to the original data
      setCityFilter(cities[0].city_id); // Reset city filter to first city
      setTxnTypeFilter("all");
      setUserTypeFilter("all");
      setAdminNameFilter("all");
  };

  const uniqueAdminNames = [...new Set(
    rows.map((row) => row.admin_name).filter(Boolean)
  )];

  const handleAdminNameFilterChange = (event) => {
    const value = event.target.value;
    setAdminNameFilter(value);

    if (value === "all") {
      setFilteredRows(rows);
    } else {
      const filtered = rows.filter(
        (row) => row.admin_name === value
      );
      setFilteredRows(filtered);
    }
  };

  // Handle Pagination Change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page
  };

    const handleCityChange = (e) =>{
        setCityFilter(e);
    }

  const handleRequestSort = (property) => {
    const isAscending = orderBy === property && order === 'asc';
    setOrder(isAscending ? 'desc' : 'asc');
    setOrderBy(property);
    const sortedRows = [...filteredRows].sort((a, b) => {
    if (a[property] < b[property]) return isAscending ? -1 : 1;
    if (a[property] > b[property]) return isAscending ? 1 : -1;
    return 0;
    });
    // setRows(sortedRows);
    setFilteredRows(sortedRows);
};

  // Update start_date and end_date based on selected date filter
  const handleDateFilterChange = (event) => {
    const filter = event.target.value;
    setDateFilter(filter);

    if (filter === "today") {
      const today = dayjs().startOf("day");
      setStartDate(today);
      setEndDate(today);
    } else if (filter === "thisWeek") {
      const startOfWeek = dayjs().startOf("week").add(1, "day");
      const endOfWeek = dayjs().endOf("week").add(1, "day");
      setStartDate(startOfWeek);
      setEndDate(endOfWeek);
    } else if (filter === "thisMonth") {
      const startOfMonth = dayjs().startOf("month");
      const endOfMonth = dayjs().endOf("month");
      setStartDate(startOfMonth);
      setEndDate(endOfMonth);
    }
  }; 

    const handleUserTypeFilterChange = (event) => {
    const value = event.target.value;
    setUserTypeFilter(value);

    if (value === "all") {
      setFilteredRows(rows);
    } else {
      const filtered = rows.filter(
        (row) => String(row.user_type) === value
      );
      setFilteredRows(filtered);
    }
  };

  // Handle driver_id search
  const handleSearchDriverId = (event) => {
    const value = event.target.value;
    setSearchDriverId(value);

    const searchKey = analyticsConfig[activeTab]?.searchKey; // Use dynamic search key
    if (!searchKey) {
        console.error("Search key not defined for the active tab.");
        return;
    }

    if (value) {
        const filtered = rows.filter((row) =>
            row[searchKey]?.toString().includes(value) // Ensure safe access
        );
        setFilteredRows(filtered);
    } else {
        setFilteredRows(rows); // Reset if input is cleared
    }
  };


    const handleSearchPromoName = (event) => {
      const value = event.target.value;
      setSearchPromoName(value);

      const searchKey = analyticsConfig[activeTab]?.searchKey; // Use dynamic search key
      if (!searchKey) {
          console.error("Search key not defined for the active tab.");
          return;
      }

      if (value) {
          const filtered = rows.filter((row) =>
            row.title?.toLowerCase().includes(value.toLowerCase())
          );
          setFilteredRows(filtered);
      } else {
          setFilteredRows(rows); // Reset if input is cleared
      } 
    };

    const handleSearchPartnerName = (event) => {
      const value = event.target.value;
      setSearchPartnerName(value);

      const searchKey = analyticsConfig[activeTab]?.searchKey; // Use dynamic search key
      if (!searchKey) {
          console.error("Search key not defined for the active tab.");
          return;
      }

      if (value) {
          const filtered = rows.filter((row) =>
            row.partner_name?.toLowerCase().includes(value.toLowerCase())
          );
          setFilteredRows(filtered);
      } else {
          setFilteredRows(rows); // Reset if input is cleared
      }
    };

    const formatTime = (eventTime) => {
      if (!eventTime) return "";

      const date = new Date(eventTime);

      const adjustedDate = new Date(
        date.getTime() + utcOffset * 60000
      );

      return adjustedDate.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: timeZoneFormat === "12"
      });
    };

    const formatDate = (eventTime) => {
      if (!eventTime) return "";

      const date = new Date(eventTime);

      const adjustedDate = new Date(
        date.getTime() + utcOffset * 60000
      );

      return adjustedDate.toLocaleDateString();
    };

  const formatRideDuration = (minutes) => {
    if (minutes === null || minutes === undefined) return "N/A";

    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;

    if (hrs === 0) {
      return `${mins} min`;
    }

    if (mins === 0) {
      return `${hrs} hr`;
    }
    
    return `${hrs} hr ${mins} min`;
  };

const groupDriverShiftReport = (data) => {
  const grouped = {};

  data.forEach((item) => {
    if (!grouped[item.driver_id]) {
      grouped[item.driver_id] = {
        driver_id: item.driver_id,
        driver_name: item.driver_name,
        phone_number: item.phone_number,
        total_duty_hours: item.total_duty_hours,
        total_shifts: item.total_shifts,
        shifts: [],
      };
    }

    grouped[item.driver_id].shifts.push({
      shift_number: item.shift_number,
      start_time: item.start_time,
      end_time: item.end_time,
    });
  });

  return Object.values(grouped);
};

const groupFleetWalletBalance = (data) => {
  const grouped = {};

  data.forEach((item) => {
    const key = item.fleet_id;
    const amount = Number(item.amount) || 0;

    if (!grouped[key]) {
      grouped[key] = {
        fleet_id: item.fleet_id,
        fleet_name: item.fleet_name,
        total_credit: 0,
        total_debit: 0,
        balance: 0,
        total_transactions: 0,
        logged_on: item.logged_on,
      };
    }

    const g = grouped[key];
    if (item.txn_type === "Credit") g.total_credit += amount;
    if (item.txn_type === "Debit") g.total_debit += amount;
    g.balance = g.total_credit - g.total_debit;
    g.total_transactions += 1;

    if (new Date(item.logged_on) > new Date(g.logged_on)) {
      g.logged_on = item.logged_on;
    }
  });

  return Object.values(grouped);
};


const generateShiftColumns = (rows) => {
  const maxShifts = Math.max(
    ...rows.map((row) => row.shifts?.length || 0),
    0
  );

  const columns = [
    { id: "driver_id", label: "Driver ID" },
    { id: "driver_name", label: "Driver Name" },
    { id: "phone_number", label: "Driver Number" },
    { id: "total_duty_hours", label: "Total Duty Hours" },
  ];

  for (let i = 1; i <= maxShifts; i++) {
    columns.push({
      id: `shift_${i}_date`,
      label: `Shift ${i} Date`,
    });

    columns.push({
      id: `shift_${i}_time`,
      label: `Shift ${i} Timing`,
    });
  }

  return columns;
};

  // Fetch Data for Active Tab
  const fetchData = async (tabIndex) => {
      setLoading(true);

      const config = visibleAnalyticsConfig[tabIndex];
      const token = localStorage.getItem("token");

      if (!token) {
          console.error("Token is missing");
          setErrorMessage("Your session has expired. Please log in again.");
          setTokenExpired(true);

          setTimeout(() => {
              navigate("/signup");
          }, 2000);
          return;
      }

      // Build dynamic params
      const params = {
          token, // Always include token
          ...(config.params.client_id && { client_id: localStorage.getItem("clientId") }),
          ...(config.params.user_type !== undefined && { user_type: config.params.user_type }),
          ...(config.params.start_date && { start_date: startDate.format("YYYY-MM-DD") }),
          ...(config.params.end_date && { end_date: endDate.format("YYYY-MM-DD") }),
          ...(config.params.city_id && { city_id: cityFilter }),
          ...(config.params.is_admin_request && { is_admin_request: config.params.is_admin_request }),
          ...(config.params.fleet_id && fleetId && { fleet_id: fleetId }),
      };

      try {
          const url = config.apiEndpoint;
          const response = await makeGetRequestToUrl(url, params);

          let modifiedData = response.data || [];

          if (config.tabName === "Driver Shift Report") {
            const groupedData = groupDriverShiftReport(response.data || []);

            setColumns(generateShiftColumns(groupedData));
            setRows(groupedData);
            setFilteredRows(groupedData);

            return;
          }
        
        if (config.tabName === "Fleet Wallet Balance") {
          const balanceData = groupFleetWalletBalance(response.data || []);
          setColumns(config.columns);
          setRows(balanceData);
          setFilteredRows(balanceData);
          return;
        }
          if (config.tabName === "Promotion Reports") {
              modifiedData = modifiedData.map((item) => ({
                  ...item,
                  promo_type:
                      item.promo_type === 1
                          ? "Percentage"
                          : item.promo_type === 2
                          ? "Flat"
                          : "Unknown",

                  is_active: item.is_active === 1 ? "Active" : "Inactive",

                  is_visible: item.is_visible === 1 ? "Yes" : "No",

                  allowed_vehicle_type:
                      item.allowed_vehicle_type === 1
                          ? "Ryde"
                          : item.allowed_vehicle_type === 2
                          ? "Bike"
                          : item.allowed_vehicle_type === 3
                          ? "Auto"
                          : "Shuttle",

                  discount_values:
                      item.discount_values === -1 ? "-" : item.discount_values,

                  discount_percentage:
                      item.discount_percentage === -1
                          ? "-"
                          : `${item.discount_percentage}%`,
              }));
          } else {
            modifiedData = modifiedData.map((item) => ({
              ...item,
              start_date: item.start_time,
              end_date: item.end_time,
              shift_timing: `${formatTime(item.start_time)} - ${formatTime(item.end_time)}`
            }));
          }

          if (response.flag === 102) {
              console.log("Token is expired. Please login again");
              localStorage.removeItem("token");
              setErrorMessage("Your session has expired. Please log in again.");
              setTokenExpired(true);

              setTimeout(() => {
                  navigate("/signup");
              }, 2000);
          }

          setColumns(config.columns);
          setRows(modifiedData || []);
          setFilteredRows(modifiedData || []);
      } catch (error) {
          console.error("Error fetching data:", error);
      } finally {
          setLoading(false);
      }
  };

const fetchPromoRedemptionData = async (promoId) => {
  try {
    setLoadingRedemptions(true);

    const params = {
      promo_id: promoId,
      start_date: startDate.format("YYYY-MM-DD"),
      end_date: endDate.format("YYYY-MM-DD"),
      token,
    };
    
    const response = await makeGetRequestToUrl(
      `${serverUrl}/panel/fetch_promo_redemptions`,
      params
    );

    if (response.flag === 200) {
      setPromoRedemptions(response.data || []);
      setDrawerOpen(true);
    }

    if (response.flag === 102) {
      localStorage.removeItem("token");
      navigate("/signup");
    }
  } catch (error) {
    console.error("Error fetching promo redemptions:", error);
  } finally {
    setLoadingRedemptions(false);
  }
};

  // Fetch Data on Initial Render
  useEffect(() => {
    fetchData(activeTab);
}, [startDate, endDate, cityFilter, activeTab,fleetId]);

const visibleAnalyticsConfig =
  client_id === "188"
    ? analyticsConfig
    : analyticsConfig.slice(0, -3);

  // Export to CSV
  const handleExportCsv = () => {
    const config = analyticsConfig[activeTab];

    // const headers = config.columns
    //   .map((col) => col.label)
    //   .join(",");
    const headers = columns
    .map((col) => col.label)
    .join(",");

    const csvRows = filteredRows.map((row) =>
      columns
        .map((col) => {
          let value = row[col.id];

          // Format start_time and end_time same as table
          if (col.id === "start_time" || col.id === "end_time") {
            value = formatTime(value);
          }

          if (col.id === "start_date" || col.id === "end_date") {
            value = formatDate(value);
          }

          if (col.id === "total_ride_time_completed_mins_per_shift") {
            value = formatRideDuration(value);
          }

          if (col.id === "total_distance_completed_per_shift") {
            value = `${value} km`;
          }

          if (col.id === "logged_on") {
            value = value ? `${formatDate(value)} ${formatTime(value)}` : "";
          }

          if (col.id.startsWith("shift_")) {
            const parts = col.id.split("_");
            const shiftIndex = parseInt(parts[1], 10) - 1;
            const fieldType = parts[2];

            const shift = row.shifts?.[shiftIndex];

            if (!shift) {
              value = "-";
            } else if (fieldType === "date") {
              value = `${formatDate(shift.start_time)} - ${formatDate(
                shift.end_time
              )}`;
            } else if (fieldType === "time") {
              value = `${formatTime(shift.start_time)} - ${formatTime(
                shift.end_time
              )}`;
            }
          }

          return `"${value ?? ""}"`;
        })
        .join(",")
    );

    const csvContent = [headers, ...csvRows].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${config.tabName}.csv`;
    link.click();
  };

  // Handle Transaction Type Filter Change
  const handleTxnTypeFilterChange = (event) => {
    const value = event.target.value;
    setTxnTypeFilter(value);

    // Apply txn_type filter to the rows
    if (value === "all") {
      setFilteredRows(rows); // Show all rows when "All Transactions" is selected
    } else {
      const filtered = rows.filter(
        (row) => row.txn_type === value // Ensure txn_type matches selected filter
      );
      setFilteredRows(filtered);
    }
  };
  
  return (
    // <div>
    //   <Navbar /> 
    //   <div style={{ display: "flex" }}>
    //     <Sidemenu />
        <div style={{ flex: 1}}>
          {/* Main Content */}
          <Typography variant="h4" style={{ marginBottom: "20px" }}>
            Analytics
          </Typography>

          {/* Tabs */}
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            sx={{
              minHeight: 'auto',
              '& .MuiTabs-flexContainer': {
                flexWrap: 'wrap',
              },
              '& .MuiTabs-indicator': {
                display: 'none',
              }
            }}
          >
            {visibleAnalyticsConfig.map((config, index) => (
              <Tab 
                sx={{
                  textTransform:'none', fontSize:'16px', border: '1px solid #D1D5DB', borderRadius:'9px', margin:'6px 8px', width:'200px',
                  color: activeTab==index ? '#fff' : '#83888E', backgroundColor: activeTab==index ? '#0065FF': '#fff','&.Mui-selected': {
                    color: '#fff'
                  },
                }} 
                key={index} label={config.tabName} 
              />
            ))}
          </Tabs>  

          {/* Filters */}
          <Grid2 container spacing={2} style={{ margin: "20px 0" }}>
            {visibleAnalyticsConfig[activeTab]?.showTxnTypeFilter && (
              <Grid2 item>
                <Select
                  value={txnTypeFilter}
                  onChange={handleTxnTypeFilterChange}
                  style={{
                    width: "200px",height:'50px',
                    backgroundColor: "white",
                    borderRadius: "10px",
                  }}
                >
                  <MenuItem value="all">All Transactions</MenuItem>
                  <MenuItem value="Credit">Credit</MenuItem>
                  <MenuItem value="Debit">Debit</MenuItem>
                </Select>
              </Grid2>
            )}
            {visibleAnalyticsConfig[activeTab]?.showCityFilter && (
              <Grid2 item>
                  <Select value={cityFilter} 
                  onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                  style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                      <MenuItem value="" disabled>Select City</MenuItem>
                      {cities.map((city) => (
                          <MenuItem key={city.city_name} value={city.city_id}>
                              {city.city_name}
                          </MenuItem>
                      ))}
                  </Select>
              </Grid2>
            )}
            {visibleAnalyticsConfig[activeTab]?.showUserTypeFilter && (
              <Grid2 item>
                <Select
                  value={userTypeFilter}
                  onChange={handleUserTypeFilterChange}
                  style={{
                    width: "200px", height: '50px',
                    backgroundColor: "white",
                    borderRadius: "10px",
                  }}
                >
                  <MenuItem value="all">All Users</MenuItem>
                  <MenuItem value="Customer">Customer</MenuItem>
                  <MenuItem value="Driver">Driver</MenuItem>
                </Select>
              </Grid2>
            )}
            {visibleAnalyticsConfig[activeTab]?.showAdminNameFilter && (
              <Grid2 item>
                <Select
                  value={adminNameFilter}
                  onChange={handleAdminNameFilterChange}
                  displayEmpty
                  style={{
                    width: "200px",
                    height: '50px',
                    backgroundColor: "white",
                    borderRadius: "10px",
                  }}
                >
                  <MenuItem value="all">All Admins</MenuItem>
                  {uniqueAdminNames.map((name) => (
                    <MenuItem key={name} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid2>
            )}
            <Grid2 item>
              <Select
                value={dateFilter}
                onChange={handleDateFilterChange}
                style={{
                  width: "200px", height:'50px',
                  backgroundColor: "white",
                  borderRadius: "10px",
                }}
              >
                <MenuItem value="today">Today</MenuItem>
                <MenuItem value="thisWeek">This Week</MenuItem>
                <MenuItem value="thisMonth">This Month</MenuItem>
                <MenuItem value="custom">Custom Range</MenuItem>
              </Select>
            </Grid2>
            {dateFilter === "custom" && (
              <>
                <Grid2 item>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDate && startDate && startDate.isAfter(endDate)
                                } 
                            }}
                            sx={{
                                width: '190px',
                                '& .MuiInputBase-root': {
                                    height: '50px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF'
                                }
                            }}
                      label="Start Date"
                      value={startDate}
                      onChange={(newValue) => setStartDate(newValue)}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Grid2>
                <Grid2 item>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker 
                      slotProps={{ 
                        textField: { 
                              size: 'small',
                              error: endDate && startDate && startDate.isAfter(endDate)
                          } 
                      }}
                      sx={{
                          width: '190px',
                          '& .MuiInputBase-root': {
                              height: '50px',
                              borderRadius: '8px',
                              backgroundColor: '#FFFFFF'
                          }
                      }}
                      label="End Date"
                      value={endDate}
                      onChange={(newValue) => setEndDate(newValue)}
                      style={{ width: "200px", backgroundColor: "white" }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Grid2>
              </>
            )}
            {visibleAnalyticsConfig[activeTab]?.showUserId && (
            <Grid2 item>
              <input style={{height:'46px', border:'1px solid #D1D5DB', paddingLeft:'12px', fontSize:'15px'}}
                type="number"
                placeholder={visibleAnalyticsConfig[activeTab]?.showUserIdPlacholeder || "User ID"}
                className="filterBtn"
                value={searchDriverId}
                onChange={handleSearchDriverId}
              />
            </Grid2>)}
            {visibleAnalyticsConfig[activeTab]?.showpromoName && (
            <Grid2 item>
              <input style={{height:'46px', border:'1px solid #D1D5DB', paddingLeft:'12px', fontSize:'15px'}}
                type="text"
                placeholder="Promo Name"
                className="filterBtn"
                value={searchPromoName}
                onChange={handleSearchPromoName}
              />
            </Grid2>)}
            {visibleAnalyticsConfig[activeTab]?.showpartnerName && (
            <Grid2 item>
              <input style={{height:'46px', border:'1px solid #D1D5DB', paddingLeft:'12px', fontSize:'15px'}}
                type="text"
                placeholder="Partner Name"
                className="filterBtn"
                value={searchPartnerName}
                onChange={handleSearchPartnerName}
              />
            </Grid2>)}
            <Grid2 item sx={{ marginLeft: "auto" }}>
                <Button
                  variant="contained"
                  onClick={handleExportCsv}
                  sx={{
                      backgroundColor: '#0DBA78', color: '#fff', border: '1px solid #0DBA78', textTransform: 'none',
                      borderRadius: '8px', minWidth:'150px', boxShadow:'none', height: '48px',
                      '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                      '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                  }}>
                  
                  <Typography sx={{marginRight:'6%'}}>Export CSV</Typography>
                  <img src={exportCSVIcon} alt="exportCSV" />
              </Button>
            </Grid2>

          </Grid2>

          {/* Table */}
          <TableContainer
            style={{
              maxHeight: "700px",
              overflowY: "auto",
              border: "1px solid #D1D5DB",
              borderRadius: "16px",
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {columns.map((col) => (
                    // Skip columns based on flags
                    (
                      (["total_online_earnings", "total_online_ride_count", "total_cash_ride_count", "total_cash_earnings", "total_expenses"].includes(col.id) &&
                        localStorage.getItem('is_rizzo_client') !== "1") ||
                      (col.id === "total_rides" && localStorage.getItem('disable_total_rides_for_taxi') === "1")
                    ) ? null : (
                      <TableCell
                        key={col.id}
                        align="center"
                        sx={{
                          backgroundColor: "#1A1E25",
                          color: "#D1D5DB",
                          fontSize: "14px",
                          border: "1px solid #e0e0e0",
                          whiteSpace: 'nowrap'
                        }}
                      >
                        <TableSortLabel
                          className="table-header"
                          active={orderBy === col.id}
                          direction={orderBy === col.id ? order : "asc"}
                          onClick={() => handleRequestSort(col.id)}
                          sx={{
                            "& .MuiTableSortLabel-icon": {
                              color: "#D1D5DB !important",
                            },
                          }}
                        >
                          {col.label}
                        </TableSortLabel>
                      </TableCell>
                    )
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredRows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, rowIndex) => (
                    <TableRow
                      key={rowIndex}
                      sx={{
                        "&:nth-of-type(odd)": { backgroundColor: "#F9F9F9" },
                        "&:hover": { backgroundColor: "#F9F9F9" },
                        "&:nth-of-type(even)": { backgroundColor: "#ffffff" },
                        "&:hover": { backgroundColor: "#ffffff" },
                      }}
                    >
                      {columns.map((col) => (
                        (
                          (["total_online_earnings", "total_online_ride_count", "total_cash_ride_count", "total_cash_earnings", "total_expenses"].includes(col.id) &&
                            localStorage.getItem('is_rizzo_client') !== "1") ||
                          (col.id === "total_rides" && localStorage.getItem('disable_total_rides_for_taxi') === "1")
                        ) ? null : (
                          <TableCell
                            key={col.id}
                            align="center"
                            sx={{
                              border: "1px solid #D1D5DB",
                              whiteSpace: "nowrap",
                              color:
                                col.label === "Total Earnings"
                                  ? "#0DBA78"
                                  : col.label === "Transaction Type"
                                  ? row[col.id] === "Credit"
                                    ? "#0DBA78"
                                    : row[col.id] === "Debit"
                                    ? "#D14545"
                                    : "inherit"
                                  : col.label === "Amount"
                                  ? row["txn_type"] === "Credit"
                                    ? "#0DBA78"
                                    : row["txn_type"] === "Debit"
                                    ? "#D14545"
                                    : "inherit"
                                  : col.label === "Status"                          
                                  ? row[col.id] === "Active"                        
                                    ? "#0DBA78"
                                    : row[col.id] === "Inactive"
                                    ? "#D14545"
                                    : "inherit"
                                  : col.label === "Balance"
                                  ? Number(row[col.id]) < 0
                                    ? "#D14545"
                                    : "#0DBA78"
                                  : "inherit",
                            }}
                          >
                            {(() => {
                              if (col.id === "shift_timing") {
                                return `${formatTime(row.start_time)} - ${formatTime(row.end_time)}`;
                              }
                              if (col.id.startsWith("shift_")) {
                                const parts = col.id.split("_");
                                const shiftIndex = parseInt(parts[1], 10) - 1;
                                const fieldType = parts[2];

                                const shift = row.shifts?.[shiftIndex];

                                if (!shift) return "-";

                                if (fieldType === "date") {
                                  return `${formatDate(shift.start_time)} - ${formatDate(
                                    shift.end_time
                                  )}`;
                                }

                                if (fieldType === "time") {
                                  return `${formatTime(shift.start_time)} - ${formatTime(
                                    shift.end_time
                                  )}`;
                                }

                                return "-";
                              }

                              if (col.id === "start_time" || col.id === "end_time") {
                                return formatTime(row[col.id]);
                              }

                              if (col.id === "start_date" || col.id === "end_date") {
                                return formatDate(row[col.id]);
                              }

                              if (col.id === "total_ride_time_completed_mins_per_shift") {
                                return formatRideDuration(row[col.id]);
                              }

                              if (col.id === "total_distance_completed_per_shift") {
                                return `${row[col.id]} km`;
                              }
                              if(col.id === "logged_on"){
                                return row[col.id] ? `${formatDate(row[col.id])} ${formatTime(row[col.id])}` : "-";
                              }

                              if (col.id === "action") {
                                return (
                                  <Button
                                    // variant="contained"
                                    sx={{
                                      backgroundColor: "white",
                                      color: "black",
                                      border: "1px solid black",
                                      textTransform: "none",
                                      borderRadius: "8px",
                                      width: "auto", // Or set a specific width
                                      minWidth: "120px",
                                      marginBottom: "10px",
                                      "&:hover": {
                                        backgroundColor: "black",
                                        color: "white",
                                      },
                                      "&:active": {
                                        backgroundColor: "black",
                                        color: "white",
                                      },
                                    }}
                                    size="small"
                                    onClick={() => {
                                      setSelectedPromotion(row);
                                      fetchPromoRedemptionData(row.promo_id);
                                    }}
                                  >
                                    View Details
                                  </Button>
                                );
                              }

                              return row[col.id] ?? "N/A";

                              
                            })()}
                          </TableCell>
                        )
                      ))}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

        <Drawer
          anchor="right"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          PaperProps={{
            sx: {
              width: "100%",
              maxWidth: "1400px",
              padding: 2,
            },
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <Typography variant="h6">
              Promo Redemption Details
            </Typography>

            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>

              <IconButton onClick={() => setDrawerOpen(false)}>
                <CloseIcon />
              </IconButton>

            </div>
          </div>

          {selectedPromotion && (
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <Typography sx={{ mb: 2 }}>
              Promotion Title: {selectedPromotion.title} ({selectedPromotion.promo_id})
            </Typography>
              <Button
                variant="contained"
                onClick={handleExportPromoRedemptionCsv}
                sx={{
                  backgroundColor: "#0DBA78",
                  textTransform: "none",
                  boxShadow: "none",
                  marginBottom:'5px',
                  "&:hover": { backgroundColor: "#0DBA78" }
                }}
                >
                Export CSV
              </Button>
              </div>
          )}

          {loadingRedemptions ? (
            <Typography>Loading...</Typography>
          ) : (
            <TableContainer
              sx={{
                border: "1px solid #D1D5DB",
                borderRadius: "12px",
                overflow:'auto',
                maxHeight:'800px'
              }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>User ID</TableCell>
                    <TableCell>User Name</TableCell>
                    <TableCell>Phone</TableCell>
                    <TableCell>Engagement ID</TableCell>
                    <TableCell>Redemption Time</TableCell>
                    <TableCell>Original Fare</TableCell>
                    <TableCell>Discount Applied</TableCell>
                    <TableCell>Final Fare</TableCell>
                    <TableCell>Promo Count</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {promoRedemptions.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.user_id}</TableCell>
                      <TableCell>{item.user_name}</TableCell>
                      <TableCell>{item.phone}</TableCell>
                      <TableCell>{item.engagement_id}</TableCell>
                      <TableCell>
                        {formatDate(item.redemption_timestamp)}{" "}
                        {formatTime(item.redemption_timestamp)}
                      </TableCell>
                      <TableCell>{item.original_fare}</TableCell>
                      <TableCell>{item.discount_applied}</TableCell>
                      <TableCell>{item.final_fare_paid}</TableCell>
                      <TableCell>{item.user_promo_count}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Drawer>

          {/* Pagination */}
          <TablePagination
            component="div"
            count={filteredRows.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />

          {loading && <Typography>Loading...</Typography>}
          {!loading && filteredRows.length === 0 && (
            <Typography 
              sx={{ 
                textAlign: 'center', 
                padding: '40px', 
                color: '#83888E',
                fontSize: '16px'
              }}
            >
              No data available for the selected filters
            </Typography>
          )}
        </div>
    //   </div>
    // </div>
  );
};

export default DynamicAnalytics;